import API from "../../api";
import { useEffect, useState } from "react";
import OrderCard from "./components/orderCard";
import OrderSuccessModal from "./components/successModal";
import { IoBag } from "react-icons/io5";
import { getSocket } from "../../services/socket_service";
import { SessionService } from "../../services/persistService";
import { useMainContext } from "../../context";

const OrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const { hasInitialized } = useMainContext();

  const findOrders = async () => {
    setLoading(true);

    try {
      const response = await API.findOrders();

      if (response.status === 200) {
        setOrders(response.data);
      }
    } catch (error) {
      console.log("Erro ao carregar os pedidos:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const userInfo = SessionService.getItem("user");
    if (!userInfo) return;

    const socket = getSocket();
    if (!socket) return;

    socket.on(`change-order-status-${userInfo.id}`, () => {
      findOrders();
    });

    return () => {
      socket.off(`change-order-status-${userInfo.id}`);
    };
  }, []);

  useEffect(() => {
    if (hasInitialized) {
      findOrders();
    }
  }, [hasInitialized]);

  return (
    <div className="p-4 md:p-8 space-y-2 flex-grow">
      {loading || !hasInitialized ? (
        Array(3)
          .fill()
          .map((_, index) => (
            <div
              key={index}
              className="w-full h-40 rounded-xl bg-gray-300 animate-pulse"
            />
          ))
      ) : orders.length === 0 ? (
        <div className="h-full flex flex-col items-center justify-center gap-2">
          <IoBag className="size-10 text-primary-500" />
          <p className="text-md text-primary-500 text-center">
            Você não possui pedidos ainda
          </p>
        </div>
      ) : (
        orders.map((order) => <OrderCard order={order} key={order.id} />)
      )}

      <OrderSuccessModal />
    </div>
  );
};

export default OrdersPage;
